import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import IconStackOverlay from '../../../../components/overlays/IconStackOverlay';
import { DEFAULT_LINK_CLASS_NAME } from '../../../../theme/constants/link';

const BaseCessionStatusOverlay = ({ overlayProps, titleProps, bodyProps }) => (
  <IconStackOverlay {...overlayProps}>
    <Typography {...titleProps}>
      No posees facturas disponibles para mostrar en el Estado de cesiones
    </Typography>
    <Typography {...bodyProps}>
      En esta página se muestran las facturas que ya has operado con nosotros.
    </Typography>
    <Typography {...bodyProps}>
      Para evaluar tus facturas y operarlas con Fingo, revisa{' '}
      <Link
        component={RouterLink}
        to="/app/sales/factoring/available"
        className={DEFAULT_LINK_CLASS_NAME}
      >
        tus facturas disponibles.
      </Link>
    </Typography>
  </IconStackOverlay>
);

BaseCessionStatusOverlay.propTypes = {
  overlayProps: PropTypes.shape({}),
  titleProps: PropTypes.shape({}),
  bodyProps: PropTypes.shape({}),
};

BaseCessionStatusOverlay.defaultProps = {
  overlayProps: {},
  titleProps: { variant: 'h4', sx: { maxWidth: 500 }, paragraph: true },
  bodyProps: { variant: 'body1', paragraph: true },
};

export default BaseCessionStatusOverlay;
